import React, { Fragment } from 'react';

import MainFooter from 'components/Core/Footer/MainFooterComponent/MainFooter';
import Hr from 'components/Shared/Hr/Hr';
import StatusCard, { CARD_STATE } from 'components/Shared/StatusCard/StatusCard';

type Props = {
  success?: boolean;
  done?: boolean;
  return: boolean;
  companyLocale: string;
  children?: React.ReactNode | string | null;
};

const StatusCardWithFooter: React.FC<Props> = (props) => {
  return (
    <React.Fragment>
      <StatusCard state={props.done || props.success ? CARD_STATE.SUCCESS : CARD_STATE.WARNING}>
        {props.children}
        <div className="card-footer">
          {props.done ? (
            <Fragment />
          ) : (
            <Fragment>
              <Hr marginBottom={15} />
              <MainFooter redesign={false} companyLocale={props.companyLocale} isPayable={false} />
            </Fragment>
          )}
        </div>
      </StatusCard>
      {/*language=SCSS*/}
    </React.Fragment>
  );
};

export default StatusCardWithFooter;
